import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=7f881d10&"
import script from "./Taxes.vue?vue&type=script&lang=js&"
export * from "./Taxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports